import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';

const UpdatesOrderProvider = (props) => {
  const api = new API();
  const [updatesOrderCatList, setUpdatesOrderCatList] = useState([]);
  const [updatesOrderSubCatList, setUpdatesOrderSubCatList] = useState([]);
  const [updatesOrderCatListLoader, setUpdatesOrderCatListLoader] = useState(false);
  const [updatesOrderSubCatListLoader, setOrderSubCatListLoader] = useState(false);
  const [updatesOrderTableFilter, setUpdatesOrderTableFilter] = useState({
    page: 1,
    limit: 100,
  })
  const [subCatOrderId, setSubCatOrderId] = useState("");
  const [updatesOrderList, setUpdatesOrderList] = useState([]);
  const [updatesOrderListLoader, setUpdatesOrderListLoader] = useState(false);
  const fetchUpdatesOrderCatList = async () => {
    setUpdatesOrderCatListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("updatesorder/categorylist", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setUpdatesOrderCatList(res?.data?.data);
        } else {
          setUpdatesOrderCatList([]);
        }
        setUpdatesOrderCatListLoader(false);
      }));
  }
  const fetchUpdatesOrderSubCatList = async (cid) => {
    setOrderSubCatListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("updatesorder/subcategorylist", {
        category_id: cid
      }, (err, res) => {
        if (res?.data?.status === 200) {
          setUpdatesOrderSubCatList(res?.data?.data);
        } else {
          setUpdatesOrderSubCatList([]);
        }
        setOrderSubCatListLoader(false);
      }));
  }
  const fetchUpdatesOrderList = async (data) => {
    setUpdatesOrderListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
    setSubCatOrderId(data?.subcategory_id);
      (await api.getAll("updatesorder/examtablelist_v3", {
        category_id: data?.category_id,
        subcategory_id: data?.subcategory_id,
        ...updatesOrderTableFilter
      }, (err, res) => {
        if (res?.data?.status === 200) {
          setUpdatesOrderList(res?.data?.data);
        } else {
          Widget.showMessage('error',err?.response?.data?.message);
          setUpdatesOrderList([]);
        }
        setUpdatesOrderListLoader(false);
      }));
  }

  const fetOrderUpdatesSub = async (data) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("pearlsorder/suborder_v2", {
        ids: data,
        subcategory_id: subCatOrderId,
        type: "updates"
      }, (err, res) => {
        if(err){
          Widget.showMessage('error',err?.response?.data?.message);
        }
      }));
  }
  const fetOrderUpdatesTopic = async (data) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("pearlsorder/suborder_v2", {
        ids: data,
        subcategory_id: subCatOrderId,
        type: "updates"
      }, (err, res) => {
        if(err){
          Widget.showMessage('error',err?.response?.data?.message);
        }
      }));
  }

   return (
    <Context.Provider value={{
      ...props,
      updatesOrderCatList, setUpdatesOrderCatList,
      updatesOrderSubCatList, setUpdatesOrderSubCatList,
      updatesOrderCatListLoader, setUpdatesOrderCatListLoader,
      updatesOrderSubCatListLoader, setOrderSubCatListLoader,
      updatesOrderTableFilter, setUpdatesOrderTableFilter,
      updatesOrderList, setUpdatesOrderList,
      updatesOrderListLoader, setUpdatesOrderListLoader,
      fetchUpdatesOrderCatList,
      fetchUpdatesOrderSubCatList,
      fetchUpdatesOrderList,
      fetOrderUpdatesSub,
      fetOrderUpdatesTopic,
      subCatOrderId, setSubCatOrderId
    }}>
      {props.children}
    </Context.Provider>
   ) 
};

export default UpdatesOrderProvider;

